module.exports = __webpack_public_path__ + "static/media/sad-tear-regular.598f9648.svg";